import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";

export class SetCarLicensePlateTempAction extends BaseAction<void, { value: string }> {
  override async run(): Promise<void> {
    try {
      updateRecoilState("carLicensePlateAtom", this.params?.value || "");
    } catch (e) {}
  }
}

export const setCarLicensePlateTempAction = new SetCarLicensePlateTempAction();